"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accumelation = void 0;
var utils_1 = require("../../utils");
exports.accumelation = function (axios) {
    return {
        /** @deprecated type이 정확하게 있는 getAccumulationsPro 사용해주세요 */
        getAccumulations: function (request) {
            return axios.get('/accumulations', request);
        },
        // get accumulations for pro
        getAccumulationsPro: function (request) {
            return axios.get('/accumulations', request);
        },
        postAccumulations: function (request) {
            return axios.post('/accumulations', request.data);
        },
        /** @deprecated type이 정확하게 있는 getAccumulationsDailyStatus를 사용해주세요 */
        getAccumulationsDaily: function (request) {
            return axios.get('/accumulations/daily', request);
        },
        // get /accumulation/daily for pro
        getAccumulationsDailyStatus: function (request) {
            return axios.get('/accumulations/daily', request);
        },
        getAccumulationsPayments: function (request) {
            return axios.get('/accumulations/payments', request);
        },
        deleteAccumulationsPayments: function (request) {
            var url = utils_1.paramPathchange('/accumulations/payments/{paymentNo}', request);
            return axios.delete(url, request);
        },
        putAccumulationsSubtract: function (request) {
            return axios.put('/accumulations/subtract', request.data);
        },
        getAccumulationsSummary: function (request) {
            return axios.get('/accumulations/summary', request);
        },
        postAccumulationsPayments: function (request) {
            return axios.post('/accumulations/payments/', request.data);
        },
        getAccumulationsPaymentsPaymentNoMembers: function (request) {
            var url = utils_1.paramPathchange('/accumulations/payments/{paymentNo}/members', request);
            return axios.get(url, request);
        },
        putAccumulationsConfigurations: function (request) {
            return axios.put('/accumulations/configurations', request.data);
        },
        getAccumulationsConfigurations: function (request) {
            return axios.get('/accumulations/configurations', request);
        },
        postAccumulationsConfigurations: function (request) {
            return axios.post('/accumulations/configurations', request.data);
        },
        putAccumulationsPaymentsPaymentNo: function (request) {
            var url = utils_1.paramPathchange('/accumulations/payments/{paymentNo}', request);
            return axios.put(url, request.data);
        },
        getAccumulationsExcel: function (request) {
            return axios.get('/accumulations/excel', request);
        },
        getAccumulationsPaymentsPaymentNo: function (request) {
            var url = utils_1.paramPathchange('/accumulations/payments/{paymentNo}', request);
            return axios.get(url, request);
        },
        getAccumulationsMembersAvailable: function (request) {
            return axios.get('/accumulations/members/available', request);
        }
    };
};
